import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "@/icons";
import i18n from "./i18n";
import higcustom from "./components/custom";

Vue.config.productionTip = false;

Vue.use(higcustom);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
